// jQuery
import './plugins/jquery-global.js';

// Slick slider
import './plugins/slick';

// mCustomScrollbar
// FIRST: INSTALL VIA `npm i malihu-custom-scrollbar-plugin` and then uncomment:
// require('malihu-custom-scrollbar-plugin')($);

// Scripts
// require('./scripts/scripts.js');

import {ui} from './scripts/_ui';
import {slider} from './scripts/_slider';
import {menu} from './scripts/_menu';

(function () {
  $(document).ready(function () {
    ui.init();
    menu.init();
    slider.init();
  });
})($);
